import RolePermissionsModal from "components/RolePermissionsModal";
import type { RoleData } from "components/RolePermissionsModal/types";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { createRole, fetchRoles } from "store/permissionsStore";
import { useAppDispatch, useAppSelector } from "store/store";

interface CreateRoleModalProps {
    open: boolean;
    onClose: () => void;
}

const CreateRoleModal = ({ open, onClose }: CreateRoleModalProps) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();
    const createRoleStatus = useAppSelector((state) => state.permissions.createRoleStatus);

    const handleSave = async (roleData: RoleData) => {
        try {
            await dispatch(createRole(roleData)).unwrap();
            toast.success(t("Roles.RoleCreatedSuccess") as string);
            onClose();
            dispatch(fetchRoles());
        } catch (error: any) {
            toast.error(error?.message || (t("Roles.RoleCreatedError") as string));
        }
    };

    return (
        <RolePermissionsModal
            open={open}
            onClose={onClose}
            onSave={handleSave}
            mode="create"
            isLoading={createRoleStatus === "pending"}
        />
    );
};

export default CreateRoleModal;
